import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { customerConfig } from '@uxdf/direct-shared-lib';
import { Observable } from 'rxjs';
import { take, map, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IsFinancialManagerGuard implements CanActivate {
  constructor(private readonly store: Store<any>) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(customerConfig),
      filter(customerState => !customerState.isLoading),
      take(1),
      map(
        customerState =>
          customerState.customerConfig.is_financial_manager || customerState.customerConfig.is_decision_maker
      )
    );
  }
}
